export default {"src":"/_next/static/media/loading.0dda9bd4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};